import dayjs, { OpUnitType } from "dayjs";


export function isOlderThan (timestamp: string, unit: OpUnitType, value: number): boolean {
    const time = dayjs.utc(timestamp);
    const now = dayjs();
    return now.diff(time, unit) > value;
}
